import * as React from 'react';
import TextField from '@mui/material/TextField';
import Dialog from '@mui/material/Dialog';
import { makeStyles } from '@mui/styles';
import { FormControl, InputAdornment } from '@mui/material';
import Box from '@mui/material/Box';
import { View as viewContext } from '@twintag/twintag-core';
import { View } from '@esoptra/zaza-sdk';
import close from '../../assets/close.svg';
import { Loader } from '@/components/blocks';
import emailIcon from '../../assets/email.svg';
import apiHelper from '../../services/ApiService';
import './SupportModal.scss';

const STYLES = {
    root: {
        width: '100%',

        '& .MuiInputLabel-root': {
            color: '#777777',
        },
        '& .MuiInputLabel-root.MuiInputLabel-filled': {
            fontSize: '16px',
        },
        '& .MuiFilledInput-root.Mui-focused.MuiFilledInput-underline::after, & .MuiOutlinedInput-root.Mui-focused fieldset.MuiOutlinedInput-notchedOutline':
            {
                borderColor: '#70BD95',
            },
        '& .MuiOutlinedInput-root ': { borderRadius: '8px' },
        '& .MuiOutlinedInput-root input': {
            padding: '10.5px 10px',
            fontSize: '16px',
        },
        '& .MuiOutlinedInput-root .MuiInputBase-inputAdornedStart': {
            paddingLeft: 0,
        },
        '& .MuiInputLabel-root.Mui-focused': {
            color: '#70BD95',
        },
    },
};

const useStyles: any = makeStyles(STYLES);

export default function SupportModal({ translation, onClose, onSubmit }: any) {
    const classes = useStyles();
    const [open, setOpen] = React.useState(false);
    const [showLoader, setShowLoader] = React.useState(false);
    const [firstname, setFirstname] = React.useState('');
    const [email, setEmail] = React.useState('');
    const [lastname, setLastname] = React.useState('');
    const [message, setMessage] = React.useState('');

    React.useEffect(() => {
        setOpen(true);
    }, []);

    const handleClose = (event?: any, reason?: any) => {
        if (reason && reason === 'backdropClick') return;
        onClose();
    };

    const submitData = async () => {
        if (firstname?.trim() && email?.trim() && message?.trim()) {
            setShowLoader(true);
            const view = new View(viewContext.getId());
            const mailContent = `\nName: ${
                firstname + ' ' + lastname
            } \nMessage: ${message} \n`;
            try {
                await view.sendFeedback(
                    JSON.parse(
                        JSON.stringify({
                            email: email,
                            subject: ' ',
                            content: mailContent.toString(),
                        })
                    )
                );
            } catch (error: any) {
                if (
                    !(
                        error &&
                        error.message &&
                        error.message.includes('failed to parse response')
                    )
                ) {
                    console.log('error', error);
                }
            }
            const bodyObj = {
                action: 'sendToSubscribers',
                body: {
                    msg: translation('support.emailResponse'),
                    recipient: email,
                }
            };
            await apiHelper.ExecuteEpsilon(bodyObj);
            setShowLoader(false);
            onSubmit();
        }
    };

    return (
        <>
            {showLoader && <Loader />}
            <Dialog open={open} onClose={handleClose} className='support-modal'>
                <div className='content'>
                    <div
                        className='close-btn cursor-pointer'
                        onClick={handleClose}
                    >
                        <img src={close} alt='' height={11} width={14} />
                    </div>
                    <div className='wrapper'>
                        <h1 className='blue-text'>
                            {translation('contact.title')}
                        </h1>
                        <br />
                        <h2>{translation('contact.subtitle')}</h2>
                        <br />
                        <FormControl
                            className={classes.root}
                            style={{ marginBottom: '24px' }}
                        >
                            <h5 style={{ marginBottom: '8px' }}>
                                {translation('contact.firstNameLabel')}
                            </h5>
                            <TextField
                                autoFocus
                                style={{
                                    width: '100%',
                                    fontFamily: 'Montserrat',
                                }}
                                placeholder={translation(
                                    'contact.firstNameLabel'
                                )}
                                onChange={(e) => setFirstname(e.target.value)}
                            />
                        </FormControl>
                        <FormControl
                            className={classes.root}
                            style={{ marginBottom: '24px' }}
                        >
                            <h5 style={{ marginBottom: '8px' }}>
                                {translation('contact.lastNameLabel')}
                            </h5>
                            <TextField
                                style={{
                                    width: '100%',
                                    fontFamily: 'Montserrat',
                                }}
                                placeholder={translation(
                                    'contact.lastNameLabel'
                                )}
                                onChange={(e) => setLastname(e.target.value)}
                            />
                        </FormControl>

                        <FormControl
                            className={classes.root}
                            style={{ marginBottom: '24px' }}
                        >
                            <h5 style={{ marginBottom: '8px' }}>
                                {translation('contact.emailLabel')}
                            </h5>
                            <TextField
                                style={{
                                    width: '100%',
                                    fontFamily: 'Montserrat',
                                }}
                                placeholder={translation('contact.emailLabel')}
                                InputProps={{
                                    startAdornment: (
                                        <InputAdornment position='start'>
                                            <img src={emailIcon} alt='' />
                                        </InputAdornment>
                                    ),
                                }}
                                onChange={(e) => setEmail(e.target.value)}
                            />
                        </FormControl>
                        <Box
                            component='form'
                            className={classes.root}
                            noValidate
                            autoComplete='off'
                            style={{ marginBottom: '1rem!important' }}
                        >
                            <div>
                                <h5 style={{ marginBottom: '8px' }}>
                                    {translation('contact.messageLabel')}
                                </h5>
                                <TextField
                                    multiline
                                    rows={4}
                                    placeholder={translation(
                                        'contact.messageLabel'
                                    )}
                                    style={{
                                        width: '100%',
                                        fontFamily: 'Montserrat',
                                    }}
                                    onChange={(e) => setMessage(e.target.value)}
                                />
                            </div>
                        </Box>

                        <div className='action-container'>
                            <button className='action-btn' onClick={submitData}>
                                {translation('contact.sendBtn')}
                            </button>
                        </div>
                    </div>
                </div>
            </Dialog>
        </>
    );
}
